export default __webpack_public_path__ + "static/072-ecb42854a4c7869c4b35fe2c7e7d7d09.jpg";